import { constant } from 'lodash/fp';
import { combineReducers } from 'redux';

import { keyById } from '@mews/fp';
import { createReducer } from '@mews/framework/redux';

import { BOOKING_RESTARTED } from '../../global/actionTypes';
import { FETCH_RESERVATION_GROUP_SUCCEEDED } from '../../reservationGroups/actionTypes';
import { FetchReservationGroupsResponse } from '../../reservationGroups/responseType';
import { PaymentsData } from './types';

const dataInitialState: PaymentsData = {};

const dataReducer = createReducer(dataInitialState, {
    [FETCH_RESERVATION_GROUP_SUCCEEDED]: (state: PaymentsData, { payments }: FetchReservationGroupsResponse) => ({
        ...state,
        ...keyById(payments),
    }),
    [BOOKING_RESTARTED]: constant(dataInitialState),
});

export const payments = combineReducers({
    data: dataReducer,
});
